import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { SunIcon, XIcon } from 'lucide-react';
import { OFFER_ANCHOR, purchaseAlerts } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
const MINUTES_AGO = [2, 3, 4, 6, 7, 9, 11, 13];
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeout: ReturnType<typeof setTimeout>;
    const showNext = () => {
      setVisible(true);
      timeout = setTimeout(() => {
        setVisible(false);
        timeout = setTimeout(() => {
          setIndex(prev => (prev + 1) % purchaseAlerts.length);
          showNext();
        }, 6000);
      }, 6000);
    };
    timeout = setTimeout(showNext, 4000);
    return () => clearTimeout(timeout);
  }, [dismissed]);
  const alert = purchaseAlerts[index];
  const minutes = MINUTES_AGO[index % MINUTES_AGO.length];
  return <AnimatePresence data-id="element-164" data-mp="164ej8hc45uny">
      {visible && !dismissed && <motion.div initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.25,
      ease: EASE
    }} role="status" aria-live="polite" className="fixed bottom-3 left-3 z-50 w-[min(17.5rem,calc(100vw-1.5rem))]" data-id="element-165" data-mp="117frg5fx9zsx">
          <div className="relative overflow-hidden rounded-lg border-[3px] border-solar bg-navy pr-7 shadow-[0_10px_28px_rgba(4,29,59,0.5)]" data-id="element-166" data-mp="i81tlcf2o4x5">
            <p className="bg-solar px-2.5 py-0.5 text-[0.6rem] font-black uppercase tracking-[0.14em] text-coal" data-id="element-167" data-mp="x6c8vb6hppo0">
              🔥 Compra verificada · Argentina
            </p>
            <div className="flex items-start gap-2.5 p-2.5" data-id="element-168" data-mp="28jy9bshsvdou">
              <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-md bg-solar" data-id="element-169" data-mp="28mkexml4rj4f">
                <SunIcon size={18} className="text-coal" strokeWidth={2.5} data-id="element-170" data-mp="23nps89k1laf1" />
              </span>
              <div className="min-w-0" data-id="element-171" data-mp="2aqxjght3c6c3">
                <p className="text-[0.76rem] font-black leading-tight text-white" data-id="element-172" data-mp="2fmuzen0fzaoc">
                  {alert.name}
                </p>
                <p className="text-[0.66rem] leading-tight text-solar" data-id="element-173" data-mp="2kniqf8oo7rik">
                  {alert.city}, {alert.country}
                </p>
                <a href={OFFER_ANCHOR} className="mt-0.5 block text-[0.68rem] font-bold uppercase leading-tight text-white underline underline-offset-2" data-id="element-174" data-mp="1rybvsksc7m2l">
                  Acabó de comprar este libro digital
                </a>
                <p className="text-[0.6rem] uppercase tracking-wide text-white/60" data-id="element-175" data-mp="21ueu1fk2j0k9">
                  Hace {minutes} minutos
                </p>
              </div>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute right-1.5 top-1.5 text-coal transition-colors duration-150 ease-soft hover:text-navy" data-id="element-176" data-mp="197c2569wdo2z">
              <XIcon size={14} data-id="element-177" data-mp="3ngo7s274bfyn" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}